import "reflect-metadata";
import CoreApp, {ConfigHelper, IServiceConfig, ThemeVars} from "@athena-portal/core";
import {Layout} from "./Layout";
import theme from "./theme/theme.scss"
import {init as initApm} from "@elastic/apm-rum"
import {CoverCheckerPage} from "./pages/CoverCheckerPage";
import {ICoverCheckerPortalService} from "./services/ICoverCheckerPortalService";
import {Types} from "./Types";
import {CoverCheckerPortalServiceImpl} from "./services/impl/CoverCheckerPortalServiceImpl";

if (process.env.REACT_APP_APM_SERVER_ENABLED?.toString() === "true") {
    initApm({
        serviceName: process.env.REACT_APP_APPLICATION_NAME,
        serverUrl: process.env.REACT_APP_APM_SERVER_URL,
        distributedTracingOrigins: process.env.REACT_APP_APM_DISTRIBUTED_TRACING_ORIGINS ? process.env.REACT_APP_APM_DISTRIBUTED_TRACING_ORIGINS.split(",") : [],
        serviceVersion: process.env.REACT_APP_APPLICATION_VERSION,
        propagateTracestate: true
    })
}

const app = new CoreApp();
const extensions = app.getExtensionPoints();

app.i18n().setAvailableLocales({
    "en-GB": {},
});

app.setTheme(theme as ThemeVars);

extensions.routes.add({
    path: "/",
    component: CoverCheckerPage,
})

extensions.services.bind<ICoverCheckerPortalService>(Types.CoverCheckerPortalService).to(CoverCheckerPortalServiceImpl);

const coverCheckerPortalConfig: IServiceConfig = {
    serviceBaseUrl: process.env.REACT_APP_FERRY_COVER_CHECKER_PORTAL_API_BASE_URL ?? "",
    customQueryStringParameters: ConfigHelper.parseMapFromString(
        process.env.REACT_APP_FERRY_COVER_CHECKER_PORTAL_API_CUSTOM_QUERY_STRING ?? ""
    ),
    customHeaders: ConfigHelper.parseMapFromString(
        process.env.REACT_APP_FERRY_COVER_CHECKER_API_CUSTOM_HEADERS ?? ""
    )
};

extensions.services.bind<IServiceConfig>(Types.CoverCheckerPortalServiceConfig).toConstantValue(coverCheckerPortalConfig);

app.render(
    <Layout/>,
    document.getElementById("root") as HTMLElement
);
